/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  UPDATE_SOLD_OUT_ITEMS,
  UPDATE_SOLD_OUT_CAN_CONTINUE_ACTION,
  UPDATE_SOLD_OUT_INVENTORY,
  UPDATE_DISPLAY_SOLD_OUT_DIALOG_FOOTER,
  UPDATE_DISPLAY_SOLD_OUT_DIALOG_TAKEAWAY_PAYMENT_SUMMARY,
} from '../../constants/actionType'

/**
 * Declare Variable
 */
const updateSoldOutItemsAction = createAction(UPDATE_SOLD_OUT_ITEMS)
const updateSoldOutCanContinueAction = createAction(UPDATE_SOLD_OUT_CAN_CONTINUE_ACTION)
const updateSoldOutInventoryAction = createAction(UPDATE_SOLD_OUT_INVENTORY)

const updateDisplaySoldOutDialogFooterAction = createAction(UPDATE_DISPLAY_SOLD_OUT_DIALOG_FOOTER)
const updateDisplaySoldOutDialogTakeawayPaymentSummaryAction = createAction(UPDATE_DISPLAY_SOLD_OUT_DIALOG_TAKEAWAY_PAYMENT_SUMMARY)

/**
 * Export
 */

export const updateSoldOutItems = (array) => (dispatch, getState) => {
  dispatch(updateSoldOutItemsAction({ soldOutItems: array }))
}
export const updateSoldOutCanContinue = (v) => (dispatch, getState) => {
  dispatch(updateSoldOutCanContinueAction({ soldOutCanContinue: v }))
}
export const updateSoldOutInventory = (obj) => (dispatch, getState) => {
  dispatch(updateSoldOutInventoryAction({ soldOutInventory: obj }))
}

export const updateDisplaySoldOutDialogFooter = (bool) => (dispatch, getState) => {
  dispatch(updateDisplaySoldOutDialogFooterAction({ display: bool }))
}

export const updateDisplaySoldOutDialogTakeawayPaymentSummary = (bool) => (dispatch, getState) => {
  dispatch(updateDisplaySoldOutDialogTakeawayPaymentSummaryAction({ display: bool }))
}



// WEBPACK FOOTER //
// ./src/actions/components/soldOut.js